import { render, staticRenderFns } from "./PdOverview.vue?vue&type=template&id=d83e0666&scoped=true&"
import script from "./PdOverview.vue?vue&type=script&lang=js&"
export * from "./PdOverview.vue?vue&type=script&lang=js&"
import style0 from "./PdOverview.vue?vue&type=style&index=0&id=d83e0666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83e0666",
  null
  
)

export default component.exports